// extracted by mini-css-extract-plugin
export var brand = "_96-9";
export var compact = "_96-6";
export var extraSmall = "_96-7";
export var icon = "_96-0";
export var large = "_96-4";
export var light = "_96-1";
export var medium = "_96-5";
export var outline = "_96-b";
export var primaryDark = "_96-a";
export var primaryLight = "_96-8";
export var primaryModern = "_96-c";
export var success = "_96-2";
export var successSolid = "_96-3";